export default function PageHeader({ title, subtitle, actions, overline }) {
    return (
        <div className="border-b border-border bg-card">
            <div className="px-6 py-6 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
                <div>
                    {overline && <div className="overline mb-2">{overline}</div>}
                    <h1
                        data-testid="page-title"
                        className="font-display text-3xl sm:text-4xl font-black tracking-tighter leading-none"
                    >
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="mt-2 text-sm text-muted-foreground max-w-2xl">{subtitle}</p>
                    )}
                </div>
                {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
            </div>
        </div>
    );
}
